import { ref } from 'vue'
import { collection, query, where, getDocs } from 'firebase/firestore'
import { db } from '@/firebase/firebase'

// 전역 상태 (composable 외부에 선언하여 상태 유지)
const currentProperty = ref(null)
const loaded = ref(false)

export function usePartnerProperty() {
  // 현장 정보 가져오기 (한 번만 로드)
  const fetchCurrentProperty = async (userId) => {
    // 이미 로드했으면 다시 로드하지 않음
    if (loaded.value) return

    if (!userId) {
      loaded.value = true
      return
    }

    try {
      const q = query(
        collection(db, 'propertyPartners'),
        where('partnerId', '==', userId),
        where('status', '==', 'active')
      )
      const snapshot = await getDocs(q)
      if (!snapshot.empty) {
        currentProperty.value = {
          id: snapshot.docs[0].id,
          ...snapshot.docs[0].data()
        }
      }
    } catch (error) {
      console.error('현장 정보 조회 실패:', error)
    } finally {
      loaded.value = true
    }
  }

  // 강제로 다시 로드 (현장 변경 시 사용)
  const refreshProperty = async (userId) => {
    loaded.value = false
    currentProperty.value = null
    await fetchCurrentProperty(userId)
  }

  // 로그아웃 시 초기화
  const clearProperty = () => {
    currentProperty.value = null
    loaded.value = false
  }

  return {
    currentProperty,
    loaded,
    fetchCurrentProperty,
    refreshProperty,
    clearProperty
  }
}
